import React from 'react'

import { Form, Col } from '_zari/core'

import { Select2Cliente, Select2Proveedor } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import { TiposSocioConstant } from 'constants/index'

import { KeyEventUtil } from 'utils'

import * as SocioCrud from 'services/socio.service'

const SocioFormGroup = ({ iError, iTouched, fIsSubmitting, iValue, values, setValues, dispatch, vTipoSocio }) => {
  const onChangeSocioHandler = pickedMember => {
    SocioCrud.obtenerxIdAsInfoSlim(pickedMember.value).then(({ data }) => {
      values._idSocio = pickedMember.value
      values.codigoSocio = data.codigo
      values.documentoSocio = data.numeroDocumento
      values.nombreSocio = data.razonSocial
      values.tipoDocumentoSocio = data.tipoDocumento

      setValues(values)

      KeyEventUtil.leaveOnKeyEvent('inputselect-glosa')
    })
  }

  const clickClear = React.useCallback(() => {
    values._idSocio = ''
    values.codigoSocio = ''
    values.documentoSocio = ''
    values.nombreSocio = ''
    values.tipoDocumentoSocio = ''

    setValues(values)

    dispatch({
      type: 'limpiar',
      payload: {}
    })

    KeyEventUtil.leaveOnKeyEvent('codigoRucSelect')
  }, [setValues, values, dispatch])

  return (
    <>
      <Form.Group>
        <Form.Label text='RUC/DNI' htmlFor='input-dniSocio' md={2} alignRightAt='md' />
        <Col md={10}>
          {iValue ? (
            <ClearInputGroup
              id='codigoRucSocio'
              iValue={`${values.documentoSocio} - ${values.nombreSocio}`}
              clickClear={clickClear}
            />
          ) : (
            <>
              {vTipoSocio === TiposSocioConstant.CLIENTE ? (
                <Select2Cliente disabled={fIsSubmitting} id='codigoRucSelect' onChange={onChangeSocioHandler} />
              ) : (
                <Select2Proveedor disabled={fIsSubmitting} id='codigoRucSelect' onChange={onChangeSocioHandler} />
              )}
            </>
          )}
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(SocioFormGroup)
